import React from 'react'
import { useSelector } from 'react-redux'
import {
  getFilters,
  getIsDataFilteredOrSorted,
  getIsLoaded,
  getPage,
  getPageCount,
  getSearchString,
  getSorter,
  getSortedCoupons,
} from 'domains/coupons/selectors'
import useAction from 'utils/useAction'
import { deleteCoupon, fetchCoupons } from 'actions/views/coupon'
import { StyledTable, Wrapper, Buttons, Breadcrumbs } from './Coupons.styles'
import SearchInTableBar from 'components/SearchInTableBar'
import { Button } from 'antd'
import getColumns from './columns'
import { getRegularRowClass, getRowKey } from 'helpers/tables'
import { FIELD_NAMES } from 'const/forms'
import { openConfirmModal, openCouponModal } from 'reducers/modals/actions'
import isEqual from 'lodash/isEqual'

const PAGE_SIZE = 20
const SCROLL = { x: 900 }
export const HEADER_OFFSET = {
  offsetHeader: 49,
}

const Coupons = () => {
  const isLoaded = useSelector(getIsLoaded)
  const page = useSelector(getPage)
  const search = useSelector(getSearchString)
  const pageCount = useSelector(getPageCount)
  const filters = useSelector(getFilters)
  const sorter = useSelector(getSorter)
  const dataSource = useSelector(getSortedCoupons)
  const isDataFilteredOrSorted = useSelector(getIsDataFilteredOrSorted)

  const fetchCouponsFunc = useAction(fetchCoupons)
  const deleteCouponFunc = useAction(deleteCoupon)
  const openConfirmModalFunc = useAction(openConfirmModal)
  const openCouponModalFunc = useAction(openCouponModal)

  const onSearchStringChange = (search) =>
    fetchCouponsFunc({
      page: 1,
      search,
      filters,
      sorter,
    })
  const handleEditCoupon = (id) => openCouponModalFunc({ id })
  const handleCreateCoupon = () => openCouponModalFunc()
  const handleDeleteCoupon = (coupon) => {
    const callback = () => deleteCouponFunc(coupon[FIELD_NAMES.id])
    const text =
      `Are you sure you want to delete coupon ${
        coupon[FIELD_NAMES.code]
      } (ID: ${coupon[FIELD_NAMES.id]})? ` + "This action can't be revoked."
    openConfirmModalFunc({ callback, text })
  }

  const onTableChange = (pagination, newFilters, newSorter) => {
    const pageChanged = page !== pagination.current
    const newFiltersOrSorter =
      !pageChanged &&
      (!isEqual(newFilters, filters) || !isEqual(newSorter, sorter))
    fetchCouponsFunc({
      page: newFiltersOrSorter ? 1 : pagination.current,
      search,
      filters: newFilters,
      sorter: newSorter,
    })
  }

  const handleResetFilters = () =>
    fetchCouponsFunc({
      search,
      page: 1,
      filters: {},
      sorter: {},
    })

  const paginationConfig = {
    position: ['bottomCenter'],
    showQuickJumper: true,
    total: pageCount * PAGE_SIZE,
    pageSize: PAGE_SIZE,
    current: page,
    showSizeChanger: false,
  }

  return (
    <Wrapper>
      <Breadcrumbs>Promotions → Coupons</Breadcrumbs>
      <SearchInTableBar
        placeholder="Search retailer here"
        onSubmit={onSearchStringChange}
        value={search}
      >
        <Buttons>
          <Button
            onClick={handleCreateCoupon}
            type="primary"
            disabled={!isLoaded}
          >
            Create
          </Button>
          <Button
            onClick={handleResetFilters}
            disabled={!isLoaded || !isDataFilteredOrSorted}
          >
            Reset filters
          </Button>
        </Buttons>
      </SearchInTableBar>
      <StyledTable
        onChange={onTableChange}
        showSorterTooltip={false}
        columns={getColumns(
          filters,
          sorter,
          handleEditCoupon,
          handleDeleteCoupon
        )}
        dataSource={dataSource}
        expandable={false}
        pagination={paginationConfig}
        sticky={isLoaded && HEADER_OFFSET}
        scroll={SCROLL}
        bordered
        loading={false}
        rowKey={getRowKey}
        rowClassName={getRegularRowClass}
      />
    </Wrapper>
  )
}

export default Coupons
